
import Vue from 'vue'
import DefaultInput from './input.vue'
export default Vue.extend({
  components: {
    DefaultInput
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    proxyValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  render() {
    return (
      <div class="input-type">
        <default-input
          {...{ attrs: { ...this.$attrs } }}
          {...{ on: { ...this.$listeners } }}
          v-model={this.proxyValue}
        />
      </div>
    )
  }
})
